import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=cd7516d4&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=cd7516d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7516d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd7516d4')) {
      api.createRecord('cd7516d4', component.options)
    } else {
      api.reload('cd7516d4', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=cd7516d4&scoped=true&", function () {
      api.rerender('cd7516d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-85aCiZ4xA6Rje/JS/comp/CookieBox.vue"
export default component.exports